/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-12-31 13:06:16                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-27 14:10:54                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * CompInfoSelectRadio: compinfo select radio type
*/

/* Imports */
import { Radio } from "@material-tailwind/react";
/***/

/**
* CompInfoSelectRadio: compinfo select radio type
* @param id - compinfo id
* @param choices - list of avaible choices
* @param values - previous selected values
* @param onChange - on change event
* @param className - Additional className
*/
export default function CompInfoSelectRadio({
  id,
  choices,
  values,
  onChange,
  className = ""
}: {
  id: string,
  choices: EasyTech.CompInfoChoice[],
  values: EasyTech.CompInfoChoice[],
  onChange: (data: EasyTech.CompInfoChoice[]) => void,
  className?: string
}) {
  /**
   * Récupère le label traduit d'un choix de compInfo selon la langue de l'utilisateur
   * @param choice - Choix contenant les traductions
   * @returns Label traduit ou label par défaut
   */
  const getTranslatedChoiceLabel = (choice: EasyTech.CompInfoChoice): string => {
    const currentLanguage = localStorage.getItem("i18nextLng") || "en";
    
    if (choice.translations && Array.isArray(choice.translations)) {
      const translation = choice.translations.find(
        (translation) => translation.language?.isoCode === currentLanguage
      );
      
      if (translation && translation.label) {
        return translation.label;
      }
    }
    
    // Fallback sur le label par défaut
    return choice.label || "";
  };

  return (
    <div className={`flex flex-col ${className}`}>
      {choices.map((choice) => (
        <div key={choice.id} className="flex items-center justify-between gap-3">
          <span className="text-sm text-gray-500">{getTranslatedChoiceLabel(choice)}</span>
          <Radio className="radio"
                 name={id}
                 defaultChecked={values[0] && values[0].id === choice.id}
                 onChange={() => onChange([choice])}
                 color="blue" />
        </div>
      ))}
    </div>
  );
}
